'use strict';

export const MxDialogManager = {
	require: {
		mxCommonDialogContentCtrl: '?^mxCommonDialogContent',
		mxDialogViewCtrl: '?^mxDialogView',
	},
	bindings: {
		triggerDataReload: '<',
		viewsToHide: '<',
		confirmationDialogEnabled: '@?',
		confirmationDialogDisabledWhenNoChanges: '@?',
		confirmationDialogTitle: '@?',
		confirmationDialogMessage: '@?',
		confirmationDialogActions: '<?',
		confirmationDialogResult: '=?',
		reloadApplicationOnSave: '@',
	},
	template: '',
	controller: MxDialogManagerController,
	controllerAs: 'vm',
};

MxDialogManagerController.$inject = ['mx.internationalization'];
export function MxDialogManagerController(i18n) {
	const vm = this;
	let dialogContentCtrl, dialogViewCtrl;

	vm.$onInit = function () {
		dialogContentCtrl = dialogContentCtrl || vm.mxCommonDialogContentCtrl || {};
		dialogViewCtrl = dialogViewCtrl || vm.mxDialogViewCtrl || {};

		dialogContentCtrl.onChangeConfirmationDialogResult(function (value) {
			if (value !== undefined) {
				vm.confirmationDialogResult = value;
			}
		});
	};

	vm.$onChanges = function (changes) {
		dialogContentCtrl = dialogContentCtrl || vm.mxCommonDialogContentCtrl || {};
		dialogViewCtrl = dialogViewCtrl || vm.mxDialogViewCtrl || {};

		Object.keys(changes).forEach(function (propertyName) {
			const handlerName = propertyName + 'ChangeHandler';
			if (typeof vm[handlerName] === 'function') {
				vm[handlerName](changes[propertyName].currentValue, changes[propertyName].previousValue);
			}
		});
	};

	vm.confirmationDialogActionsChangeHandler = function (value) {
		dialogContentCtrl.confirmationDialog.actions = value;
	};

	vm.viewsToHideChangeHandler = function (views) {
		views = views || [];

		dialogViewCtrl.view.tabs.forEach(function (view) {
			view.visible = views.indexOf(view.Key) === -1;
		});

		if (!dialogViewCtrl.view.selectedTab.visible) {
			dialogViewCtrl.view.selectedTab = dialogViewCtrl.view.tabs.find((tab) => tab.visible);
		}
	};

	vm.reloadApplicationOnSaveChangeHandler = function (reload) {
		if (reload !== undefined) {
			dialogContentCtrl.reloadPageOnSave = reload === 'true';
			dialogViewCtrl.hideSaveButton(reload === 'true');
			dialogViewCtrl.setDoneButtonLabel(reload === 'true' && i18n.get('solutionBuilderAgent.layouts.dialog.dialog-manager.saveAndReloadApplication'));
		}
	};

	vm.triggerDataReloadChangeHandler = function onTriggerDataReloadChanged(reload) {
		if (reload && typeof dialogContentCtrl.reloadObject === 'function') {
			dialogContentCtrl.reloadObject();
		}
	};

	vm.confirmationDialogEnabledChangeHandler = function (value) {
		if (value !== undefined) {
			dialogContentCtrl.confirmationDialog.enabled = value === 'true';
		}
	};

	vm.confirmationDialogDisabledWhenNoChangesChangeHandler = function (value) {
		if (value !== undefined) {
			dialogContentCtrl.confirmationDialog.disabledWhenNoChanges = value === 'true';
		}
	};

	vm.confirmationDialogTitleChangeHandler = function (value) {
		if (value !== undefined) {
			dialogContentCtrl.confirmationDialog.title = value;
		}
	};

	vm.confirmationDialogMessageChangeHandler = function (value) {
		if (value !== undefined) {
			dialogContentCtrl.confirmationDialog.message = value;
		}
	};
}
